export const getTotalEventAttendees = (state) => {
  const { eventDates, eventDailyGuests } = state.form.application.values;

  return (eventDailyGuests * eventDates.length).toString();
};

export const getIsAppDataLoaded = (state) => {
  const isStatesLoaded = !!state.formPage.usStates.length;
  const isEventsLoaded = !!state.formPage.eventTypes.length;

  return isStatesLoaded && isEventsLoaded;
};

export const getIsInMaintenanceMode = (state) => state.formPage.maintenanceMode;
